import { add } from 'date-fns'
import { HistorySelection, SelectionDetail } from 'types/selections'

import { DATE_CUTOFF_LAPORAN_KEMENDAGRI } from 'app/resources'

export const getIsSelectionEndedAfterKemendagriCutoff = (
  selection: SelectionDetail | HistorySelection
) => {
  const selectionEndDate = new Date(selection.endDate)
  const cutoffDate = new Date(DATE_CUTOFF_LAPORAN_KEMENDAGRI)

  return (
    selectionEndDate.getTime() >=
    add(cutoffDate, {
      minutes: selectionEndDate.getTimezoneOffset(),
    }).getTime()
  )
}
